import { render } from "./SuggestedProductsModal.vue?vue&type=template&id=3ee02d84"
import script from "./SuggestedProductsModal.vue?vue&type=script&lang=js"
export * from "./SuggestedProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__